import {Brand} from '../../models/brand.model';
import {SearchQueryParams} from '../../models/search-query-params.model';
import {ValidationError} from '../../models/validation-error.model';

export namespace BrandsActions {
    export class GetListPage {
        static readonly type = 'BrandsActions.GetListPage';

        constructor(public params?: SearchQueryParams) {
        }

    }

    export class Add {
        static readonly type = 'BrandsActions.Add';

        constructor(public brand: Brand) {
        }
    }

    export class Delete {
        static readonly type = 'BrandsActions.Delete';

        constructor(public brand: Brand) {
        }
    }

    export class FieldList {
        static readonly type = 'BrandsActions.FieldList';

        constructor(public readonly brand: string) {
        }
    }

    export class FilteredBrandList {
        static readonly type = 'BrandsActions.FilteredBrandList';

        constructor(public readonly brand: string) {
        }
    }

    export class FormFailure {
        static readonly type = 'BrandsActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class SetModalVisibility {
        static readonly type = 'BrandsActions.SetModalVisibility';

        constructor(public readonly isVisible: boolean) {
        }
    }

    export class BrandsSearchList {
        static readonly type = 'BrandsActions.BrandsSearchList';

        constructor(public readonly searchData: { codeSearch: string }) {
        }
    }

    export class ModelSearchList {
        static readonly type = 'BrandsActions.ModelSearchList';

        constructor(public readonly searchData: { codeSearch: string, brand: string }) {
        }
    }

    export class ModelListClear {
        static readonly type = 'BrandsActions.ModelListClear';
    }

}

